<script setup lang="ts">
import { onMounted, ref } from 'vue'

const chartOptions = ref({
  labels: ["Android", "iOS"]
})
const series = ref([11, 32])
</script>

<template>
  <apexchart
    ref="donut"
    width="100%"
    type="donut"
    :options="chartOptions"
    :series="series"
  ></apexchart>
</template>

<style scoped>

</style>
